import React, { useState,useEffect	 } from "react";
import { Link } from "react-router-dom";
import { collectionTicker,contractAddress } from "config";
import { routeNames } from "routes";
import * as Dapp from "@elrondnetwork/dapp";
//
import { MapContainer, TileLayer} from "react-leaflet";
import {GeoJSON,} from "react-leaflet";
import { FeatureCollection } from 'geojson';
import { Button, Modal,Image,Carousel} from 'react-bootstrap';
//
import {decodeBase64,highlightFeature,resetHighlightFeature,getProfileNFTs,getCollections} from "./Function";
import axios from "axios";
import ReactLoading from "react-loading";
import data_world from '../Map/json/world.json';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import { RawTransactionType } from "helpers/types";
import useNewTransaction from "pages/Transaction/useNewTransaction";
import { isMobile } from 'react-device-detect';
import data_profile from './res.json';
import logo from "./../../assets/img/world_flip.gif";

interface NFT {
	attributes: string;
	collection: string;
	creator: string;
	identifier: string;
	isWhitelistedStorage: boolean;
	name: string;
	nonce: number;
	royalties: number;
	tags?: string[];
	thumbnailUrl: string;
	ticker: string;
	timestamp: number;
	type: string;
	uris: string[];
	url: string;
}

interface List {
	name: string;
	quantity: number;
	rarity: string;
}

const MapView = () => {
  const { address,apiAddress,loggedIn } = Dapp.useContext();

  const [selectCountry, setSelectCountry] = useState<string>()

	const [homeShow, setHomeShow] = useState(true)
  const [nftShow, setNftShow] = useState(false)
  const [nftCollectionShow, setNftCollectionShow] = useState(false)

	const [collection_src] = useState<string[]>(["https://dweb.link/ipfs/bafybeic2ngwwvqpoaihvqra6frmuaxcwwvbakvjrmixhsz6yaljv3y6bvq/Southeast%20Asia.gif","https://dweb.link/ipfs/bafybeifw3usaoq4gbktv2iirx2h7lntxph2kjfsivclhm45jsowmkcjhjy/Central%20Asia.gif","https://dweb.link/ipfs/bafybeigaikvw37jcknuv2wuxqvcc4rxn6u5oi6welw6alm3nn3yxftigki/Map%20of%20Persia.gif","https://dweb.link/ipfs/bafybeier4ue5kmaj3haogmetk7f4ekr43eqg44bz3du23qkd5cs2srv7di/Black%20Sea.gif","https://dweb.link/ipfs/bafybeif7elghkphmx5a2ujnhvc37om5jq4c6fr5waa4fjbt47jue7pulnu/Adriatic%20Coastline.gif","https://dweb.link/ipfs/bafybeibg6uuf2ierkt3gc6f4c3kohwn2ozw5z7xbym5iz2vrmk62x456lu/Carte%20du%20Paraguay.gif","https://dweb.link/ipfs/bafybeigcdr367phdz7ozcf2kgu6ompdailrrq4rndtdgcpqmvoralecu4y/Central%20America.gif","https://dweb.link/ipfs/bafybeicrkqyfg3aqwwe66drfjy66layt3uuq6fs63tv5cyoxfqhldqwgmu/West%20Africa.gif","https://dweb.link/ipfs/bafybeidlb2bcqert3zatbq7vdw3pshd5fwh2gv5wfhzlabwzacdpzgvlza/East%20Africa.gif","https://dweb.link/ipfs/bafybeifnlcbllt2r6cylet6cxbma7bh6kyqt34gp3kbywpefxsmlaptp34/Map%20du%20Congo%20et%20du%20Pays%20des%20Cafres.gif","https://dweb.link/ipfs/bafybeifsxsb2hcf7pmygknry5odvy3xdo4adchqmfb2pkfk3mocywlvpoa/Saudi%20Arabia.gif","https://dweb.link/ipfs/bafybeibausdw7lrb4ruyfek6xjtyqiun5uwh5t3sec2c6whzl4aclvfiva/Mexico.gif","https://dweb.link/ipfs/bafybeifi5zxqzmz75h2r6ybswsp7qlcswxkhu4ty2imisogzm7u7vtfeci/Austria.gif","https://dweb.link/ipfs/bafybeieyf6b72zeb5ky4xjz7uvlthp2ourhp73rweuwygb7lyi5c5doqvq/Australia.gif","https://dweb.link/ipfs/bafybeifef27azoxnd5x444qvkvmmlcx5m77kpraqyfrygpnokwbhybufdy/Belgium.gif","https://dweb.link/ipfs/bafybeihpiyjmc2fr5zxefxaxmqu6vmbnthgfcmejxnzivspknp2bqizpny/Brasil.gif","https://dweb.link/ipfs/bafybeia2n5usktv2bxhl3ygsioi3gg5rhwsmncq3dq2fyh2x2kcxsq7tai/Bulgaria%20&%20Romania.gif","https://dweb.link/ipfs/bafybeift24tryvo3z62tj6232bq2jwzkpsj6kvfon6p4qfcafeorkbn6iy/Canada.gif","https://dweb.link/ipfs/bafybeiawxoowa3dejxvowswwpw3xhqelmxip7m4ocaldtmnmby7mdnjiae/China.gif","https://dweb.link/ipfs/bafybeigb74romshuweyhveuzlmbnpkltl4sw6lpmkhnlspcf3b5kgvmsau/Colombia.gif","https://dweb.link/ipfs/bafybeieso3hpulk2grdikd2gsidaoejxd5dia3q5uljbwnwdqqubkotraa/Denmark.gif","https://dweb.link/ipfs/bafybeid7wbcabgnwyejulykus3g5i4o5klxxknyqoxxsf7dytkctgris4e/Egypt.gif","https://dweb.link/ipfs/bafybeidzotzzilsym7xwowvufx52anf6oosou7qxodew74fvfl7epkwbvq/British%20Isles.gif","https://dweb.link/ipfs/bafybeiez3ott5jge7cens4npjjhupvwbuebkxsjlo4wa5qrpwcxhtdp7hu/French%20Empire.gif","https://dweb.link/ipfs/bafybeigfzisz7m2vrq6sz4ffcpxj4cllkgidbltejd4c76uoiweejh7sy4/German%20Empire.gif","https://dweb.link/ipfs/bafybeihp4idawhnhvh2agjvwelqoua2n6qk2gqhvpsgijat3r5jijblz4q/Holland.gif","https://dweb.link/ipfs/bafybeihi7j3vqg5vszixb3az4mui6ztnrs3jowtzppbznklxdsku3ftera/Greece.gif","https://dweb.link/ipfs/bafybeiapakzupsokl6xtk5owoo2jjvp6ixjx5l5zz65c2gs24kravct3gm/Italy.gif","https://dweb.link/ipfs/bafybeifsjnkw6w42xwcxkbdxdk74nsw2wnzydzgagn4lttegktnwv5to3i/Hindoostan.gif","https://dweb.link/ipfs/bafybeiccj6bqiklkp3tczwds6nryag7msio5ns3sxgn2jr4x6sse5mhtmm/Hungary.gif","https://dweb.link/ipfs/bafybeicb6bbzl4xex6znng4d3bsq6ye2xbgk6aothm43lhbjzixd4ekjde/Japan.gif","https://dweb.link/ipfs/bafybeigl3uhb544js5vq5tkffo2ulqtvqqpultcfizvmw3kasko7nqaxg4/Korea.gif","https://dweb.link/ipfs/bafybeifc54sjzuzbrgrxqadgd4t7o7n3yntm3qbr4r4snia4gckg4sghki/New%20Zealand.gif","https://dweb.link/ipfs/bafybeia7mwx5de7zqwl7ka5oe2cdod3svz5ctfku7uwil747rfvpfqrteq/Scandinavia.gif","https://dweb.link/ipfs/bafybeie75ms64p2wzm3xkd7rv6mfcagh4l47mw2rrpwacbmornmcrapwbm/Poland.gif","https://dweb.link/ipfs/bafybeiexrllaplnu4vgxcz2qkjr23s3brd75sm3doms2wtu3jaffyl4txq/Russian%20Empire.gif","https://dweb.link/ipfs/bafybeibjgnzta3vfnvxqovb5zd5umgh6wxbpigkbfzg3r2wpbyplvy4pna/South%20Africa.gif","https://dweb.link/ipfs/bafybeibwgsiypfagmikxcqa4lz6lmuhzow4aeuvfhm6aiq3mfk2vfvwzuq/Spain%20&%20Portugal.gif","https://dweb.link/ipfs/bafybeid7trfceoy5or4v3ox5lvo2m3jevdjhhigdkh2mgqevp3evkxlkvu/Switzerland.gif","https://dweb.link/ipfs/bafybeia7wc4h2df4rvj77kpprjarf5p2durfdzqvitedhw5j4att5rcvfa/East%20Mediterranean.gif","https://dweb.link/ipfs/bafybeidzz5dzij2dn7z6wwjihjpun7wj6ldmncdml3k5zob6xyi44iiyrq/United%20States%20of%20America.gif"])

  const [ profileNFT, setProfileNFT ] = useState<NFT[]>()
	const [ collectionNFT, setCollectionNFT ] = useState<NFT[]>()

	const [countries_loaded_label, setCountries_loaded_label] = useState(false)
	const [countries_loaded, setCountries_loaded] = useState<string[]>([])

  const [done,setDone]=useState(false);
	const [doneHome,setDoneHome]=useState(false);

  const [nftCollection, setNftCollection] = useState(false)

  const [jsonData,setJsonData] = useState<any>({"type":"FeatureCollection","features":[]})


	const sendTransaction = Dapp.useSendTransaction();
  const newTransaction = useNewTransaction();
	const [countries_loaded_list, setCountries_loaded_list] = useState<List[]>([])
	const columns = [
    { dataField: 'quantity', text: 'Quantity' },
    { dataField: 'name', text: 'Name' },
		{ dataField: 'rarity', text: 'Rarity'},
  ]
  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 3,
    lastPageText: '>>',
    firstPageText: '<<',
    nextPageText: '>',
    prePageText: '<',
    showTotal: false,
    alwaysShowAllBtns: true,
		hideSizePerPage:true,
  })
  useEffect(() => {
    if (!profileNFT && !collectionNFT) {
      fetchProfileNFTs()
    }else{
      getData()
			getData_alo()
    }
  },[profileNFT,loggedIn])

	const fetchProfileNFTs = async () => {
		var res = await getProfileNFTs(address,apiAddress);
		var res_collection = await getCollections(apiAddress);
		if ( res.success && res.data){
			setProfileNFT(res.data);


			for (let data_profile of res.data)
				if (data_profile.collection === collectionTicker){
					setNftCollection(true)
				}
		}
		if ( res_collection.success && res_collection.data){
			setCollectionNFT(res_collection.data.length);
		}
	}

	async function getData_alo() {
		if (profileNFT) {
			console.log(profileNFT);
			for (let data_profile of profileNFT){
		    if (data_profile.collection === collectionTicker && data_profile.name!=="eWorld" && !nftCollection) {
          let tmp_list:List[] = countries_loaded_list
          let quantity = 0
          for (let data_profile_check of profileNFT){
            if (data_profile.name.replace(/[#].*/, "") === data_profile_check.name.replace(/[#].*/, "")) {
              quantity ++
            }
          }
          let statue = false
          for (let count_check of countries_loaded_list){
            if (data_profile.name.replace(/[#].*/, "") === count_check.name ) {
              statue = true
            }
          }
					let { data } = await axios.get(`https://dweb.link/ipfs/${decodeBase64(data_profile.attributes).replace('metadata:', '')}`,)
					let rarity = data.properties.rarity*100
          if (!statue) {
            tmp_list.push({name: data_profile.name.replace(/[#].*/, ""), quantity: quantity,rarity:rarity.toFixed(2)+"%"})
            setCountries_loaded_list(tmp_list)
          }
		    }
		  }
			let tmp:List[] = countries_loaded_list
			for (let sort_first in countries_loaded_list) {
				for (let sort_second in countries_loaded_list) {
					if (parseInt(countries_loaded_list[sort_second].rarity.replace("%", "")) >= parseInt(countries_loaded_list[sort_first].rarity.replace("%", ""))) {

						let tmp_sort:List = countries_loaded_list[sort_first]

						tmp[sort_first] = countries_loaded_list[sort_second]
						tmp[sort_second] = tmp_sort
					}
				}
			}
			setCountries_loaded_list(tmp)
			setDoneHome(true)
		}
	}
  const send = () => {
    let dataTransaction = "mintPartOfTheWorld";
    let gasLimit = 100000000;
    let mintcontract = contractAddress;
    const transaction: RawTransactionType = {
      receiver: mintcontract,
      data: dataTransaction,
      value: "0.3",
      gasLimit: Number(gasLimit),
    };
    sendTransaction({
      transaction: newTransaction(transaction),
      callbackRoute: `${routeNames.map}`,
    });
  };
  async function getData() {
		if (profileNFT) {
			for (let data_profile of profileNFT){
		    if (data_profile.collection === collectionTicker && !countries_loaded.includes(data_profile.name.replace(/[#].*/, "")) && data_profile.name!=="eWorld" && !nftCollection) {
					let { data } = await axios.get(`https://dweb.link/ipfs/${decodeBase64(data_profile.attributes).replace('metadata:', '')}`,)
          data.properties.countries?.forEach((country:string) => {
		        for (let json_country of data_world['features']){
		          if (json_country.properties.brk_a3  === country) {
		            for (let json_country_exist of jsonData['features']){
		              if (json_country_exist.properties.brk_a3 === json_country.properties.brk_a3){
		                setCountries_loaded_label(true)
		              }
		            }
		            if (!countries_loaded_label) {
									let tmp_countries_loaded = countries_loaded
									tmp_countries_loaded.push(data_profile.name.replace(/[#].*/, ""))

                  let tmp_jsonData = jsonData
                  tmp_jsonData["features"].push(json_country)
									setCountries_loaded(tmp_countries_loaded)
		              setJsonData(tmp_jsonData)
		              setCountries_loaded_label(false)
		            }
		          }
		        }
		      })
		    }
		  }
      setDone(true)
		}
	}
  function onEachFeature(feature:any,layer:any) {
    layer.on({
        click: selectedCountry,
        mouseover: highlightFeature,
        mouseout: resetHighlightFeature,
    });
  }
	const styleMap = (feature:any) => {
	  let color:string = ""
	  for (let data_country of data_profile['collection']) {
	    data_country.countries?.forEach((country:string) => {
	      if (country === feature.properties.brk_a3) {
	        color = data_country.color
	      }
	    })
	  }
	  return ({fillColor: color,weight: 1,opacity: 1,color: '#bfbfbf',dashArray: '3',fillOpacity: 0.2});
	}
	const selectedCountry = async (e:any) => {
		if(profileNFT){
			for (let data_profile of profileNFT){
				if (data_profile.collection === collectionTicker && data_profile.name!=="eWorld") {
					let { data } = await axios.get(`https://dweb.link/ipfs/${decodeBase64(data_profile.attributes).replace('metadata:', '')}`,)
					data.properties.countries?.forEach((country:string) => {
						if (country === e.target.feature.properties.brk_a3) {
							setSelectCountry(data_profile.url)
						}
					})
				}
			}
		}
    setNftShow(true)
  }
	function setModalNftToCollection() {
    setNftShow(false)
		setNftCollectionShow(true)
  }
	function setModalNftToHome() {
    setNftShow(false)
		setHomeShow(true)
  }
	function setModalHomeToCollection() {
    setNftCollectionShow(true)
		setHomeShow(false)
  }
	function setModalCollectionToHome() {
    setNftCollectionShow(false)
		setHomeShow(true)
  }
	function Home() {
    return (
			<>
	      {!done && loggedIn && nftCollection ?(<ReactLoading
		          className="mx-auto my-auto"
		          type={"bars"}
		          color={"#000"}
		          height={100}
		          width={100}
		        />):(<div >
			        {!isMobile ? (<Modal
			          show={homeShow}
								onHide={() => setHomeShow(false)}
			          aria-labelledby="contained-modal-title-vcenter"
			          centered
			          size="lg"
			          className="flex"
			          animation={false}
			        >
			          <Modal.Header className="bg-light rounded text-center" style={{borderColor:"transparent"}}>
			            <Modal.Title className="mx-auto text-dark" style={{fontSize: "40px"}}>Collect a piece of eWRLD</Modal.Title>
			          </Modal.Header>
			          <Modal.Body className="w-100 mx-auto bg-light text-dark text-center" style={{color:"#f5f5f5",fontSize: "24px"}}>A collection of NFTs ready to be released on @elrondnetwork
								<Button disabled className=" bg-light text-dark font-weight-bold mx-6" style={{borderRadius: "20px",height:"4.5vh",borderColor:"transparent"}} size="lg" >Minted : {collectionNFT} / 4444</Button>
			          </Modal.Body >
			          <Modal.Footer className="bg-light rounded " style={{borderColor:"transparent",marginBottom:"0vh"}}>
			            <div className="col-md-12 text-center">
			                <Button onClick={() => setHomeShow(false)}className="shadow bg-dark my-auto " variant="primary font-weight-bold" style={{borderRadius: "20px",height:"5vh",marginBottom:"0vh",marginRight:"0vw"}} size="lg">
			                  <Image src={logo} className="elrond-logo" />
			                </Button>
			              {loggedIn ?
			                (<Button onClick={send}className="shadow bg-dark text-light font-weight-bold mx-6" style={{borderRadius: "20px",height:"5vh"}} size="lg" >
			                  MINT
			                </Button>):(<Link to={routeNames.unlock}>
			                  <Button className="shadow bg-dark text-light font-weight-bold mx-6" style={{borderRadius: "20px",height:"5vh"}} size="lg" >
			                    MINT
			                  </Button>
			                </Link>)
			              }
			                <Button onClick={() => setModalHomeToCollection()}className="shadow bg-dark text-light font-weight-bold" style={{borderRadius: "20px",height:"5vh"}} size="lg">
			                  Collection
			                </Button>
			            </div>
									<p className="font-weight-normal text-dark my-auto" style={{fontSize: "20px"}}>Parts of your world.</p>
			            <div className="mx-auto w-100 "  >
			            {(nftCollection && loggedIn) ?
										(<BootstrapTable
										keyField='rarity'
										data={countries_loaded_list}
										columns={columns}
										pagination={pagination}
										bordered
										striped

										rowStyle={{borderColor:"transparent"}}
										>
										</BootstrapTable>):null}
			            </div>
			          </Modal.Footer>
			        </Modal>):
			        (<Modal
			          show={homeShow}
			          aria-labelledby="contained-modal-title-vcenter"
								onHide={() => setHomeShow(false)}
			          centered
			          size="sm"
			          className="flex"
			          animation={false}
								style={{marginTop:"0vh"}}
			        >
			          <Modal.Header style={{borderColor:"transparent",}}>
			            <Modal.Title className="mx-auto text-dark" style={{color:"#f5f5f5",fontSize: "26px"}}>Collect a piece of eWRLD</Modal.Title>
			          </Modal.Header>
			          <Modal.Body  className="mx-auto text-center text-dark" style={{color:"#f5f5f5",fontSize: "16px"}}>A collection of unique NFTs ready to be released on @elrondnetwork
								<Button disabled className=" bg-light text-dark font-weight-bold mx-6" style={{borderRadius: "20px",height:"4.5vh",borderColor:"transparent"}} size="lg" >Minted : {collectionNFT} / 4444</Button>
								</Modal.Body>
			          <Modal.Footer className="" style={{borderColor:"transparent",}}>
			            <div className="col-md-12 text-center">
			              <Button onClick={() => setHomeShow(false)} className="primary font-weight-bold" style={{marginBottom:"0.5vh",height:"6vh"}} size="lg" >
			                <Image src={logo} className="elrond-logo" />
			              </Button>
										{loggedIn ?
			                (<Button onClick={send}className="shadow bg-dark text-light font-weight-bold mx-3" style={{marginBottom:"0.5vh",marginLeft:"0.5vw",height:"6vh"}} size="lg" >
			                  MINT
			                </Button>):(<Link to={routeNames.unlock}>
			                  <Button className="shadow bg-dark text-light font-weight-bold mx-3" style={{marginBottom:"0.5vh",marginLeft:"0.5vw",height:"6vh"}} size="lg" >
			                    MINT
			                  </Button>
			                </Link>)
			              }
			                <Button onClick={() => setModalHomeToCollection()} className="shadow bg-dark text-light font-weight-bold" style={{marginBottom:"0.5vh",marginLeft:"0.5vw",height:"6vh"}} size="lg">
			                  Collection
			                </Button>
			            </div>
									<p className="font-weight-normal text-dark my-auto" style={{fontSize: "20px"}}>Parts of your world.</p>
									<div className="mx-auto w-100 ">
			            {(nftCollection && loggedIn) ?
										(<BootstrapTable
										keyField='rarity'
										data={countries_loaded_list}
										columns={columns}
										pagination={pagination}
										bordered
										striped
										>
										</BootstrapTable>):null}
			            </div>
			          </Modal.Footer>
			        </Modal>)}
			      </div>)}
	    </>
		)
	}
  function Nft() {
    return (
      <Modal
          show={nftShow}
          onHide={() => setNftShow(false)}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="fade my-modal"
          style={{zIndex:10000}}
        >
          <Modal.Body>
						<Image src={selectCountry}/>
          </Modal.Body>
          <Modal.Footer className="" style={{borderColor:"transparent",marginBottom:"10vh"}}>
						{isMobile ? (<Button style={{borderRadius: "20px",}}className="shadow bg-light text-dark font-weight-bold" size="lg" onClick={() => setNftShow(false)}>
							Back
						</Button>):null}
						<Button style={{borderRadius: "20px",}}className="shadow bg-light text-dark font-weight-bold  mx-3" size="lg" onClick={() => setModalNftToHome()}>
							Home
						</Button>
            <Button style={{borderRadius: "20px",}} className="shadow bg-light text-dark font-weight-bold" size="lg" onClick={() => setModalNftToCollection()}>
              Collection
            </Button>
          </Modal.Footer>
        </Modal>
		)
	}
  function NftCollection() {
    setNftShow(false)
    return(
      <Modal
        show={nftCollectionShow}
        onHide={() => setNftCollectionShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="fade my-modal"
        style={{zIndex:10000}}
      >
        <Modal.Body>
          <Carousel>
            {collection_src?.map(
              (key:string,i:number) => (
                <Carousel.Item key={i}>
									<Image
                    className="d-block w-100"
                    src={key}
                  />
                </Carousel.Item>
              )
            )}
          </Carousel>
        </Modal.Body>
        <Modal.Footer className="" style={{borderColor:"transparent",marginBottom:"10vh"}}>
					{isMobile ?(<Button style={{borderRadius: "20px",}}className="shadow bg-light text-dark font-weight-bold mx-3" size="lg" onClick={() => setNftCollectionShow(false)}>
						Back
					</Button>):null}
					<Button style={{borderRadius: "20px",}}className="shadow bg-light text-dark font-weight-bold " size="lg" onClick={() => setModalCollectionToHome()}>
						Home
					</Button>
        </Modal.Footer>
      </Modal>
    )

  }
	function GeoJsonnn() {

    return(
			<>
			<GeoJSON
			data={jsonData as FeatureCollection}
			style={styleMap}
			onEachFeature={onEachFeature}
			/>
			</>
		)
  }
  return (
    <>
    {loggedIn && (!done && !doneHome)  ? (<ReactLoading
          className="mx-auto my-auto"
          type={"bars"}
          color={"#000"}
          height={100}
          width={100}
        />):(<>
	      <MapContainer
	      center={[44.4322500,26.1062600]}
	      zoom={4}
	      zoomControl={false}
	      scrollWheelZoom={true}
	      >
	        <TileLayer
	          url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiY291c3RlYXUiLCJhIjoiY2t3YXZlbHIzMDRuazJwbjJsbHRpMzF3ciJ9.zCLyEFaLTZriIfrZ3xA7BA"
	          id='mapbox/dark-v9'
	          tileSize={512}
	          zoomOffset={-1}
	          noWrap={false}
	          minZoom={3}
	        />
					<GeoJsonnn/>
	      </MapContainer>
				{homeShow ?
	        (<Home/>)
	      : null}
	      {nftShow ?
	        (<Nft/>)
	      : null}
	      {nftCollectionShow ?
	        (<NftCollection/>)
	      : null}
			</>)}
      </>
  )
}


export default MapView;
